import { render, staticRenderFns } from "./PepViewReceitas.vue?vue&type=template&id=4ba6de8d&"
import script from "./PepViewReceitas.vue?vue&type=script&lang=js&"
export * from "./PepViewReceitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports